export default __webpack_public_path__ + "static/media/header_line.30c38656.svg";